import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from "@mui/material";
import OCR_Photo_Demo from "../OCR_Photo_Demo.png";

const OCRDemoDialog = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>圖片上傳示例</DialogTitle>
    <DialogContent>
      {/* <Typography variant="body1" sx={{ mb: 2 }}>
        拍照時請盡量只包括你想要辨識的手寫文字，避免背景或頁首/頁尾的文字等無關內容，這樣能提升OCR辨識的準確度。
      </Typography> */}
      <Typography variant="body1" sx={{ mb: 2 }}>
        請確保圖片中只有清晰的手寫文字，並避免拍攝與手寫文章內容無關的部分（像是頁首/頁尾的文字或背景），這樣能提升OCR辨識的準確度。
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        ⚠️注意:手寫辨識的準確度會因書寫方式而有所不同，請盡量書寫清晰工整以達至最佳效果。
      </Typography>
      <Box sx={{ textAlign: "center", mb: 2 }}>
        <img
          src={OCR_Photo_Demo}
          alt="圖片上傳示例"
          style={{
            maxWidth: "90%",
            borderRadius: 8,
            border: "1px solid #eee",
            pointerEvents: "none", // Prevents interaction
            userSelect: "none",
          }}
          onContextMenu={(e) => e.preventDefault()}
          onDragStart={(e) => e.preventDefault()}
        />
        <Typography variant="caption" display="block" sx={{ mt: 1 }}>
          示例：圖片中只有需要辨識的手寫文字
        </Typography>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>關閉</Button>
    </DialogActions>
  </Dialog>
);

export default OCRDemoDialog;
